import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'
  import PlaceholderShimmer from '@/components/common/PlaceholderShimmer.vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import SearchBreadcrumbs from '@/components/curated-content/SearchBreadcrumbs.vue'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useCourse from '@/composables/useCourse'
  import { CourseModule } from '@/store/modules/course'
  import useEditor from '@/composables/useEditor'
  import eventBus from '@/main'
  import type { PropType } from 'vue'
  import type { CourseSearchItem as CourseSearchItemState } from '@/services/interfaces/Course'
  import type { Nullable } from '@/services/interfaces/Content'
  import { useRoute } from 'vue-router/composables'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseSearchItem',
  props: {
    searchItem: {
      required: true,
      type: Object as PropType<CourseSearchItemState>,
    },
  },
  setup(__props) {

const props = __props;

  

  const route = useRoute()
  const { formatPhrase } = useCommonMixin()
  const { showStartCourseForFreeModal, openLessonModal, courseSectionsAssignedCourses, course } = useCourse()
  const { decodeAndParseSource } = useEditor(route)

  const courseIsPurchasedOrInTrial = computed(() => {
    const _course = courseSectionsAssignedCourses.value?.find((c) => c.id === props.searchItem.course.id)
    if (_course) return _course.purchased || _course.trial
    return props.searchItem.course.purchased || props.searchItem.course.trial
  })

  const showLessonModal = async () => {
    const searchItemCourseId = props.searchItem.course.id

    // ensure course is loaded first
    if (course.value?.id !== searchItemCourseId) {
      eventBus.$emit('turn-on-loader')
      await CourseModule.getCourse({ courseId: searchItemCourseId })
      eventBus.$emit('turn-off-loader')
    }

    const loadCourseModules = async () => {
      await CourseModule.getCourseModules(searchItemCourseId)
    }

    if (courseIsPurchasedOrInTrial.value) {
      openLessonModal({
        lessonId: props.searchItem.id,
        moduleId: props.searchItem.module.id,
        courseId: searchItemCourseId,
        teaserImageUrl: props.searchItem.course.teaserImageUrl,
        formatContent: true,
      })
      await loadCourseModules()
    } else {
      eventBus.$emit('turn-on-loader')
      await loadCourseModules()
      eventBus.$emit('turn-off-loader')
      showStartCourseForFreeModal(searchItemCourseId)
    }
  }

  const crumbs = computed(() => {
    return [
      {
        id: props.searchItem.course.id,
        title: props.searchItem.course.title,
        url: `/courses/${props.searchItem.course.id}/info`,
      },
      {
        id: props.searchItem.module.id,
        title: props.searchItem.module.name,
        url: `/courses/${props.searchItem.course.id}/module/${props.searchItem.module.id}/start`,
      },
      {
        id: props.searchItem.id,
        title: props.searchItem.title,
      },
    ]
  })

  const maxContentHeight = ref(0)
  const excerptRef = ref(null as Nullable<any>)

  const formatExcerpt = (excerpt: string) => {
    return excerpt.replaceAll('\\*', '*') || ''
  }

  onMounted(() => {
    if (excerptRef.value) {
      excerptRef.value.$el.childNodes?.forEach((el: HTMLElement) => {
        const { scrollHeight } = el
        if (scrollHeight + maxContentHeight.value <= 84) {
          maxContentHeight.value += scrollHeight
        } else if (maxContentHeight.value + 20 <= 84) {
          maxContentHeight.value += 20
        }
      })
      maxContentHeight.value = Math.max(maxContentHeight.value, 80)
    }
  })

return { __sfc: true,props, route, formatPhrase, showStartCourseForFreeModal, openLessonModal, courseSectionsAssignedCourses, course, decodeAndParseSource, courseIsPurchasedOrInTrial, showLessonModal, crumbs, maxContentHeight, excerptRef, formatExcerpt, computed, onMounted, ref, PlaceholderShimmer, HTMLRenderer, SearchBreadcrumbs, useCommonMixin, useCourse, CourseModule, useEditor, eventBus, useRoute }
}

})